import { useMemo } from 'react'
import Navbar from './components/Navbar/Navbar'
import Hero from './components/Hero/Hero'
import About from './components/About/About'
import Experience from './components/Experience/Experience'
import Projects from './components/Projects/Projects'
import Skills from './components/Skills/Skills'
import Contact from './components/Contact/Contact'
import Footer from './components/Footer/Footer'
import ScrollToTop from './components/ScrollToTop/ScrollToTop'
import { experience, projects, skills, social } from './data/portfolio'
import styles from './App.module.css'

const App = () => {
  const sections = useMemo(
    () =>
      [
        'about',
        experience.length && 'experience',
        projects.length && 'projects',
        skills.length && 'skills',
        social.email && 'contact',
      ].filter(Boolean),
    []
  )

  const indexOf = (id) => String(sections.indexOf(id) + 1).padStart(2, '0')

  return (
    <>
      <a href="#main" className={styles.skipLink}>
        Skip to content
      </a>

      <span id="top" />

      <Navbar sections={sections} />

      <main id="main">
        <Hero />
        <About index={indexOf('about')} />
        <Experience index={indexOf('experience')} />
        <Projects index={indexOf('projects')} />
        <Skills index={indexOf('skills')} />
        <Contact index={indexOf('contact')} />
      </main>

      <Footer />
      <ScrollToTop />
    </>
  )
}

export default App
